import types from './types';
import api from "../api";
import {createError, logError, logSuccess} from "./message";
import {getMasterClassFull, getMasterClassCard, getMasterClassStudents} from "./actions";
import {getGroupStudents} from "../../../../../Study/Groups/store/actions";

function requestMasterClassUpdate() {
  return {
    type: types.UPDATE_MASTER_CLASS_REQUEST,
    isUpdatingMasterClass: true
  };
}

function requestMasterClassUpdateCompleted(updatedMasterClass) {
  return {
    type: types.UPDATE_MASTER_CLASS_COMPLETED,
    isUpdatingMasterClass: false,
    updatedMasterClass
  };
}

function requestMasterClassUpdateError(updateMasterClassError) {
  return {
    type: types.UPDATE_MASTER_CLASS_ERROR,
    isUpdatingMasterClass: false,
    updateMasterClassError
  };
}

export function updateMasterClass(id, data) {
  return dispatch => {
    dispatch(requestMasterClassUpdate());
    return api.updateMasterClass(id, data)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassUpdateCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
          logSuccess("Данные мастер-класса успешно обновлены");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassUpdateError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassUpdateError(createError("Не удалось обновить данные мастер класса")));
        }
      });
  };
}

//update Logo
function requestMasterClassLogoUpdate() {
  return {
    type: types.UPDATE_MASTER_CLASS_LOGO_REQUEST,
    isUpdatingLogo: true
  };
}

function requestMasterClassLogoUpdateCompleted(updatedLogo) {
  return {
    type: types.UPDATE_MASTER_CLASS_LOGO_COMPLETED,
    isUpdatingLogo: false,
    updatedLogo
  };
}

function requestMasterClassLogoUpdateError(logoUpdateError) {
  return {
    type: types.UPDATE_MASTER_CLASS_LOGO_ERROR,
    isUpdatingLogo: false,
    logoUpdateError
  };
}

export function updateMasterClassLogo(id, file) {
  return dispatch => {
    dispatch(requestMasterClassLogoUpdate());
    return api.updateLogo(id, file)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassLogoUpdateCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassLogoUpdateError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassLogoUpdateError(createError("Не удалось обновить данные мастер класса")));
        }
      });
  };
}

//update Document
function requestMasterClassDocumentUpdate() {
  return {
    type: types.UPDATE_MASTER_CLASS_FILE_REQUEST,
    isUpdatingMasterClassFile: true
  };
}

function requestMasterClassDocumentUpdateCompleted(updatedMasterClassFile) {
  return {
    type: types.UPDATE_MASTER_CLASS_FILE_COMPLETED,
    isUpdatingMasterClassFile: false,
    updatedMasterClassFile
  };
}

function requestMasterClassDocumentUpdateError(fileUpdateError) {
  return {
    type: types.UPDATE_MASTER_CLASS_FILE_ERROR,
    isUpdatingMasterClassFile: false,
    fileUpdateError
  };
}

export function updateMasterClassDocument(id, file) {
  return dispatch => {
    dispatch(requestMasterClassDocumentUpdate());
    return api.updateDocument(id, file)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassDocumentUpdateCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassDocumentUpdateError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassDocumentUpdateError(createError("Не удалось обновить данные мастер класса")));
        }
      });
  };
}

//change status
function requestMasterClassChangeStatus() {
  return {
    type: types.CHANGE_MASTER_CLASS_STATE_REQUEST,
    isChangingStatus: true
  };
}

function requestMasterClassChangeStatusCompleted(changedStatus) {
  return {
    type: types.CHANGE_MASTER_CLASS_STATE_COMPLETE,
    isChangingStatus: false,
    changedStatus
  };
}

function requestMasterClassChangeStatusError(statusChangeError) {
  return {
    type: types.CHANGE_MASTER_CLASS_STATE_ERROR,
    isChangingStatus: false,
    statusChangeError
  };
}

export function changeMasterClassStatus(id, actionName) {
  return dispatch => {
    dispatch(requestMasterClassChangeStatus());
    return api.changeMasterClassState(id, actionName)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassChangeStatusCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassChangeStatusError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassChangeStatusError(createError("Не удалось обновить статус мастер класса")));
        }
      });
  };
}

function createStudentRequest() {
  return {
    type: types.CREATE_NEW_STUDENT_REQUEST,
    isCreatingStudent: true
  };
}

function createStudentCompleted(createdStudent) {
  return {
    type: types.CREATE_NEW_STUDENT_COMPLETED,
    isCreatingStudent: false,
    createdStudent
  };
}

function createStudentError(studentCreationError) {
  return {
    type: types.CREATE_NEW_STUDENT_ERROR,
    isCreatingStudent: false,
    studentCreationError
  };
}

export function createNewStudent(id, data) {
  return dispatch => {
    dispatch(createStudentRequest());
    return api.createNewStudent(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(createStudentCompleted(response.data));
          dispatch(getMasterClassStudents(id));
          logSuccess("Новый обучающийся успешно добавлен");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createStudentError(message));
        } else {
          logError(err);
          dispatch(createStudentError(createError("Не удалось отправить запрос добавления обучающегося")));
        }
      });
  };
}

function addExistStudentRequest() {
  return {
    type: types.ADD_EXIST_STUDENT_REQUEST,
    isAddingStudent: true
  };
}

function addExistStudentCompleted(addedStudent) {
  return {
    type: types.ADD_EXIST_STUDENT_COMPLETED,
    isAddingStudent: false,
    addedStudent
  };
}

function addExistStudentError(studentAdditionError) {
  return {
    type: types.ADD_EXIST_STUDENT_ERROR,
    isAddingStudent: false,
    studentAdditionError
  };
}

export function addExistStudent(id, studentId) {
  return dispatch => {
    dispatch(addExistStudentRequest());
    return api.addStudent(id, studentId)
      .then(response => {
        if (response.status === 200) {
          dispatch(addExistStudentCompleted(response.data));
          dispatch(getMasterClassStudents(id));
          logSuccess("Обучающийся успешно добавлен на мастер-класс");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(addExistStudentError(message));
        } else {
          logError(err);
          dispatch(addExistStudentError(createError("Не удалось отправить запрос добавление обучающегося")));
        }
      });
  };
}

export default {
  updateMasterClass,
  updateMasterClassLogo,
  updateMasterClassDocument,
  changeMasterClassStatus,
  createNewStudent,
  addExistStudent
};
